import React, {FC} from 'react';

import {InboxModel} from '../../../models/api/inboxModel';
import {SettingsInboxesUrl} from '../../../models/url/settingsUrlModel';
import {SettingsPanelId} from '../../../store/panels/panelStateBase';
import {useFetchChannel} from '../../fetchers/channels';
import {SettingsSingleChannel} from './settingsSingleChannel';

/*
 * Props.
 */

interface SettingsSingleChannelProps {
  channelId: number;
  inbox: InboxModel;
  url: SettingsInboxesUrl;
  panelId: SettingsPanelId;
}

/*
 * Component.
 */

export const SettingsSingleChannelContainer: FC<SettingsSingleChannelProps> = (props) => {
  const {channel} = useFetchChannel(props.channelId);
  const {inbox, url, panelId} = props;

  if (!channel) {
    return null;
  }

  return <SettingsSingleChannel panelId={panelId} channel={channel} inbox={inbox} url={url} />;
};
